/* Gustharts: one uniform "Technical Details" spec table everywhere */
(function () {
  if (window.ghSpecTablesLoaded) return;
  window.ghSpecTablesLoaded = true;
  var TITLE = 'Technical Details';
  var HEAD_RE = /(technical|specification|specs?\b|tech\s+data|data\s*sheet|product\s+details|product\s+information)/i;

  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }

  function pairTable(pairs) {
    var t = el('table', 'gh-spec-table'), tb = el('tbody');
    pairs.forEach(function (p) {
      var tr = el('tr'), th = el('th'), td = el('td');
      th.scope = 'row'; th.innerHTML = p[0]; td.innerHTML = p[1];
      tr.appendChild(th); tr.appendChild(td); tb.appendChild(tr);
    });
    t.appendChild(tb); return t;
  }

  /* returns {pairs: [[label, value]], variants: {head: [...], rows: [[...]]} | null} */
  function parse(table) {
    var headRow = table.tHead && table.tHead.rows[0];
    var heads = headRow ? [].slice.call(headRow.cells) : [];
    var rows = [].slice.call(table.querySelectorAll('tbody tr'));
    if (heads.length > 2 && rows.length >= 1) {
      var common = [], varying = [];
      heads.forEach(function (h, i) {
        var vals = rows.map(function (r) { return r.cells[i] ? txt(r.cells[i]) : ''; });
        var same = vals.every(function (v) { return v === vals[0]; });
        if (same && rows.length > 1) { if (vals[0]) common.push(i); }
        else if (rows.length === 1) { if (vals[0]) common.push(i); }
        else varying.push(i);
      });
      var pairs = common.map(function (i) { return [heads[i].innerHTML, rows[0].cells[i].innerHTML]; });
      var variants = null;
      if (varying.length) {
        variants = {
          head: varying.map(function (i) { return heads[i].innerHTML; }),
          rows: rows.map(function (r) { return varying.map(function (i) { return r.cells[i] ? r.cells[i].innerHTML : ''; }); })
        };
      }
      return { pairs: pairs, variants: variants };
    }
    var p = [];
    [].slice.call(table.rows).forEach(function (r) { if (r.cells.length >= 2) p.push([r.cells[0].innerHTML, r.cells[1].innerHTML]); });
    return { pairs: p, variants: null };
  }

  function variantTable(v) {
    var t = el('table', 'gh-spec-table gh-spec-table--variants'), th = el('thead'), hr = el('tr'), tb = el('tbody');
    v.head.forEach(function (h) { var c = el('th'); c.scope = 'col'; c.innerHTML = h; hr.appendChild(c); });
    th.appendChild(hr); t.appendChild(th);
    v.rows.forEach(function (r) {
      var tr = el('tr');
      r.forEach(function (c, i) { var n = el(i === 0 ? 'th' : 'td'); if (i === 0) n.scope = 'row'; n.innerHTML = c; tr.appendChild(n); });
      tb.appendChild(tr);
    });
    t.appendChild(tb); return t;
  }

  /* finds the table's outer wrapper and the heading directly above it */
  function locate(table) {
    var wrap = table.parentElement, ref = table;
    while (wrap && wrap.children.length === 1 && !wrap.matches('.js-readmore-content, .product-info, .product-specifications')) { ref = wrap; wrap = wrap.parentElement; }
    var prev = ref.previousElementSibling;
    while (prev && prev.matches('p') && !txt(prev)) prev = prev.previousElementSibling;
    var isHead = !!prev && /^H[1-6]$/.test(prev.tagName);
    var isLabel = !!prev && /^(P|DIV)$/.test(prev.tagName) && txt(prev).length < 60 && !prev.querySelector('table') && HEAD_RE.test(txt(prev));
    return { ref: ref, head: (isHead || isLabel) ? prev : null, isHead: isHead };
  }

  function run() {
    [].forEach.call(document.querySelectorAll('.product-info table, .product-specifications table'), function (t) {
      if (t.closest('.gh-spec')) return;
      var inSpec = !!t.closest('.product-specifications');
      var loc = locate(t);
      var headText = loc.head ? txt(loc.head) : '';
      /* in the description only convert tables titled as specifications; leave comparison, size and compatibility tables alone */
      if (!inSpec) {
        var cols = t.rows[0] ? t.rows[0].cells.length : 0;
        var specLike = HEAD_RE.test(headText) || (!loc.head && cols === 2);
        if (!specLike) return;
      }
      if (loc.head && (inSpec || HEAD_RE.test(headText))) loc.head.parentNode.removeChild(loc.head);
      var data = parse(t);
      var sec = el('section', 'gh-spec'), h = el('h2', 'gh-spec__title');
      h.textContent = TITLE; sec.appendChild(h);
      if (data.pairs.length) { var b = el('div', 'gh-spec__box'); b.appendChild(pairTable(data.pairs)); sec.appendChild(b); }
      if (data.variants) {
        var lab = el('p', 'gh-spec__sub'); lab.textContent = 'Variants'; sec.appendChild(lab);
        var vb = el('div', 'gh-spec__box gh-spec__box--scroll'); vb.appendChild(variantTable(data.variants)); sec.appendChild(vb);
      }
      loc.ref.parentNode.replaceChild(sec, loc.ref);
    });
  }
  /* run before the read-more logic measures heights */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
